import { GlobalApiClient } from './global-api.client';

export interface IPermissionDto {
  subject: string;
  target: string;
  role: string;
  permissionType: string;
  status: string;
  attributes?: Record<string, unknown>;
}

async function listMyPermissions(params?: { includeRoles?: string[] }): Promise<IPermissionDto[]> {
  const queryParams = new URLSearchParams();

  if (params?.includeRoles) {
    queryParams.append('includeRoles', params.includeRoles.join(','));
  }

  const res = await GlobalApiClient.get<IPermissionDto[]>(`/permissions/me?${queryParams.toString()}`);
  return res.data;
}

export const permissionService = {
  listMyPermissions,
};
